export default {
    api_root:"",
    userId:"",
    load:false,
    activeName:"1",
    countData:{},
    list:[],
    pageNum:1,
    listCount:0,
    listLoading:false,
    weChatList:[],//公众号列表
    weChatCount:0,//公众号数量
    weChatPage:1,//公众号页数
    selectChatArr:[],//选择的公众号appid
    showSyncModel:false,//选择公众号弹窗
    syncId:"",
    selectPicArr:[],//选中的图片id
    showUploadModel:false,//上传弹窗
    uploadForm:{},//上传图片表单数据
    uploadImg:[],//上传的图片列表
    editImgModel:false,// 编辑图片弹窗
    editForm:{},
    keyword:"",// 模板标题搜索关键字
    showTemplatePanel1:false,// 显示模板弹窗
    showTemplatePanel2:false,// 显示模板弹窗
    sending:false,//是否请求中
    templateForm:{
        color:{
            "firstColor":"#000",
            "remarkColor":"#000",
            "keyword1Color":"#000",
            "keyword2Color":"#000",
            "keyword3Color":"#000",
            "keyword4Color":"#000",
            "keyword5Color":"#000"
        },

    },// 模板表单数据
    templateData:{},// 模板数据
    templateId:"",//选择的模板id
    templateList:[],//模板列表
    templateCount:0,//模板列表数量
    templatePage:1,//模板列表页数
    isAddTemplate:false,//是否是模板处理

}
